
import React from 'react';
import { Button } from "@/components/ui/button";
import { Calendar } from 'lucide-react';

const ComplianceHeader: React.FC = () => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Compliance Management</h1>
        <p className="text-muted-foreground">
          Monitor and manage all regulatory compliance activities.
        </p>
      </div>
      <div className="flex gap-4">
        <Button className="bg-compliance-600 hover:bg-compliance-700">
          <Calendar className="mr-2 h-4 w-4" /> Open Compliance Calendar
        </Button>
      </div>
    </div>
  );
};

export default ComplianceHeader;
